import { NgIf } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { ComponentsModule, DialogService, SnackBarService } from '@mastechnicaegroup/carelinelive-ui';
import { DeleteMessagesDialogComponent } from '../../../dialogs/message-actions/delete/delete-messages-dialog.component';
import { BehaviorSubject, catchError, of, tap } from 'rxjs';
import { ReadMessagesDialogComponent } from '../../../dialogs/message-actions/read/read-messages-dialog.component';
import { UnReadMessagesDialogComponent } from '../../../dialogs/message-actions/unread/unread-messages-dialog.component';
import { selectedThread } from '@lib/messages/message.service';

@Component({
  selector: 'app-messages-actions',
  imports: [ComponentsModule, NgIf],
  templateUrl: './messages-actions.component.html',
  styleUrl: './messages-actions.component.scss'
})
export class MessagesActionsComponent {
  @Input() selectedThreadIds: string[] = [];
  @Output() clearSelection = new EventEmitter<void>();
  @Output() refreshData = new EventEmitter<void>();

  private readonly _snackBar = inject(SnackBarService);
  private readonly _dialog = inject(DialogService);
  private readonly refreshTrigger$ = new BehaviorSubject<void>(undefined);

    onClearClicked() {
      this.clearSelection.emit();
    }

    deleteThreads() {
      return DeleteMessagesDialogComponent.show(this._dialog, { ids: this.selectedThreadIds }).closed.pipe(
          tap(() => {
              const currentSelectedThread = selectedThread();
              if (currentSelectedThread && this.selectedThreadIds.includes(currentSelectedThread.id)) {
                  selectedThread.set(null);
              }
              this.refreshTrigger$.next();
              this.clearSelection.emit();
              this.refreshData.emit();
          }),
          catchError(() => {
              this._snackBar.open({
                  colour: 'error',
                  dismissable: false,
                  icon: 'error_outline',
                  title: 'Failed to delete messages',
                  actions: [
                      { id: 'undo', label: 'OK' }
                  ]
              });
              return of(null);
          })
      ).subscribe();
  }

  readThreads() {
    return ReadMessagesDialogComponent.show(this._dialog, { ids: this.selectedThreadIds }).closed.pipe(
        tap(() => {
            this.refreshTrigger$.next();
            this.clearSelection.emit();
            this.refreshData.emit();
        }),
        catchError(() => {
            this._snackBar.open({
                colour: 'error',
                dismissable: false,
                icon: 'error_outline',
                title: 'Failed to read messages',
                actions: [
                    { id: 'undo', label: 'OK' }
                ]
            });
            return of(null);
        })
    ).subscribe();
  }

  unReadThreads() {
    return UnReadMessagesDialogComponent.show(this._dialog, { ids: this.selectedThreadIds }).closed.pipe(
        tap(() => {
            this.refreshTrigger$.next();
            this.clearSelection.emit();
            this.refreshData.emit();
        }),
        catchError(() => {
            this._snackBar.open({
                colour: 'error',
                dismissable: false,
                icon: 'error_outline',
                title: 'Failed to unread messages',
                actions: [
                    { id: 'undo', label: 'OK' }
                ]
            });
            return of(null);
        })
    ).subscribe();
  }
}
